class StoriesSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiperElement = this.querySelector(".swiper");
    this.init();
  }

  init() {
    this.swiper = new Swiper(this.swiperElement, {
      loop: true,
      slidesPerView: 1,
      navigation: {
        nextEl: this.querySelector(".custom-swiper-button-next"),
        prevEl: this.querySelector(".custom-swiper-button-prev"),
      },
      pagination: {
        el: this.querySelector(".custom-swiper-pagination"),
      },
    });
  }
}

customElements.define("stories-swiper", StoriesSwiper);
